<ng-container *ngIf="!preview">
    <ng-container *ngTemplateOutlet="promotionTemplate"></ng-container>
</ng-container>
<ng-container *ngIf="preview">
    <ng-container *ngTemplateOutlet="previewPromotionTemplate"></ng-container>
</ng-container>

<ng-template #promotionTemplate>
    <div class="promotion-container">
        <ng-container *ngIf="!!promotion; else promotionLoading">
            <div class="media-container">
                <ng-container *ngIf="isTeaserDisplay">
                    <div class="promotion-teaser" [@teaserAnimation]>
                        <div class="promotion-teaser-text">
                            <ng-container *ngIf="promotion?.teaser; else noText">
                                {{promotion.teaser}}
                            </ng-container>
                            <ng-template #noText>
                                <ng-container *ngIf="!promotion?.teaserDisabled">
                                    {{ 'PREMIUM_PROMOTION_PREVIEW_TEASER' | translate }}
                                </ng-container>
                            </ng-template>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="!isTeaserDisplay && promotion?.medias?.length">
                    <ng-container *ngFor="let media of promotion.medias; let i = index">
                        <ng-container *ngIf="i === localIndexSelected">
                            <div class="media">
                                <!-- IMAGE -->
                                <div class="image-container" *ngIf="media?.type === 'Image'" [appBackgroundImage]="media.sourceUrl"
                                    (readyToDisplayImage)="initTimerImage();"></div>
                                <!-- Video Youtube/Vimeo -->
                                <div class="video-container">
                                    <app-smash-player *ngIf="media?.type === 'Vimeo' || media?.type === 'Youtube'" 
                                        [source]="playerSource"
                                        [options]="playerOptions" 
                                        context="promotion"
                                        (ended)="navigateMediaRight()">
                                    </app-smash-player>
                                </div>
                                <!-- Iframe -->
                                <div class="iframe-container" *ngIf="media?.type === 'Iframe'">
                                    <app-smash-iframe [scriptUrl]="media?.sourceUrl" (ready)="initTimerImage();"></app-smash-iframe>
                                </div>
                            </div>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
            <div *ngIf="!isTeaserDisplay && promotion?.medias?.length === 0" class="empty-media"></div>

            <div class="promotion-preview-footer">
                <ng-container *ngIf="promotion?.text; else noPromotionTitle">
                    <div class="title">
                        <p [innerHtml]="promotion.text | safeHtml"></p>
                    </div>
                </ng-container>
                <ng-template #noPromotionTitle>
                    <div class="title">
                        <p [innerHtml]="'PREMIUM_PROMOTION_PREVIEW_DESCRIPTION' | translate | safeHtml"></p>
                    </div>
                </ng-template>
                <div class="promotion-preview-footer-right-container">
                    <ng-container *ngIf="promotion?.medias?.length > 1">
                        <div class="navigation-arrows-container">
                            <div class="icon-navigation-left" (click)="navigateMediaLeft()">
                                <i class="icon-smash_arrow_navigation icon-navigation icon-navigation-left"></i>
                            </div>
                            <div class="pager">{{ localIndexSelected + 1 }} / {{ promotion.medias.length }}</div>
                            <div class="icon-navigation-right" (click)="navigateMediaRight()">
                                <i class="icon-smash_arrow_navigation icon-navigation icon-navigation-right"></i>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="promotion?.button; else noCallToAction">
                        <div class="cta-container">
                            <div class="btn dark" *ngIf="!!action?.translation" (click)="openPromotionLink($event)">
                                {{ action.translation | translate}}
                            </div>
                        </div>
                    </ng-container>
                    <ng-template #noCallToAction>
                        <button class="btn dark">{{ 'PREMIUM_PROMOTION_PREVIEW_BUTTON' | translate }}</button>
                    </ng-template>
                </div>
            </div>
            <app-smash-iframe class="additional-iframe" [scriptUrl]="promotion.additionalIframe" *ngIf="promotion.additionalIframe">
            </app-smash-iframe>     
        </ng-container>
        <ng-template #promotionLoading>
            <div class="content-overlay">
                <div class="loading-spinner-container">
                    <div class="loading-spinner-grey"></div>
                </div>
            </div>
        </ng-template>
    </div>
</ng-template>

<ng-template #previewPromotionTemplate>
    <div class="preview-uploader-container">
        <ng-container *ngIf="promotionLoading">
            <div class="loading-spinner-container">
                <div class="loading-spinner-grey"></div>
            </div>
        </ng-container>
        <ng-container *ngIf="promotion">
            <div class="catch-click"></div>
            <div class="preview-uploader-preview">
                <ng-container *ngIf="promotion?.medias?.length; else noMedias" >
                    <div *ngFor="let media of promotion.medias; let i = index" class="preview-uploader-preview-content">
                        <ng-container *ngIf="i === localIndexSelected">
                            <!-- IMAGE -->
                            <div class="preview-uploader-preview-media image" *ngIf="media?.type === 'Image'" 
                                appElementResize 
                                appBackgroundImage={{media.sourceUrl}}>
                            </div>
                            <!-- YOUTUBE && VIMEO PLAYER -->
                            <div class="preview-uploader-preview-media image" *ngIf="media?.type === 'Youtube' || media?.type === 'Vimeo'"
                                appElementResize
                                appBackgroundImage={{media.thumbnail}}>
                                <i class="icon-smash_videos icon-video"></i>
                            </div>
                            <!-- Iframe -->
                            <div class="iframe-container" *ngIf="media?.type === 'Iframe'">
                                <app-smash-iframe [scriptUrl]="media?.scriptUrl" (ready)="initTimerImage()"></app-smash-iframe>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>
                <ng-template #noMedias>
                    <div class="empty-media"></div>
                </ng-template>
            </div>
            <div class="preview-uploader-preview-footer">
                <div class="fake-description"></div>
                <div class="fake-button">
                    <div class="fake-button-label"></div>
                </div>
            </div>
        </ng-container>
    </div>
</ng-template>